import moment from "moment";
const removeDateTimezoneFromString = (str) => {
  return str.replace(/T/, " ").replace(/Z$/, "");
};
const parsers = {
  string: (value) => (value && value.toString ? value.toString() : ""),
  boolean: (value) => (value !== null ? !!value : null),
  integer: (value) => (value === null ? null : Math.round(1 * value)),
  decimal: (value) => (value === null ? null : 1 * value),
  date: (dateString, options = {}) => {
    if (dateString === null) return null;
    if (typeof dateString === "string") {
      const value = removeDateTimezoneFromString(dateString);
      if (options.format) {
        const parsed = moment(value, options.format);
        if (parsed.isValid()) return parsed.toDate();
        return null;
      } else {
        return moment(value).toDate();
      }
    }
    return dateString && moment(dateString).toDate();
  },
};

export default parsers;
